export const CRUD_CHANGE_LIST_PARAMS = 'CRUD_CHANGE_LIST_PARAMS';
export const SET_ALL_SELECTED = 'SET_ALL_SELECTED';
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS';

export const SET_SELECTED_SEARCH_CONDITIONS = 'SET_SELECTED_SEARCH_CONDITIONS';
export const SET_ADD_SEARCH_CONDITIONS = 'SET_ADD_SEARCH_CONDITIONS';
export const SET_REMOVE_SEARCH_CONDITIONS = 'SET_REMOVE_SEARCH_CONDITIONS';

export const REFRESH_VIEW = 'REFRESH_VIEW';

export const SET_POPUP_ALL_SELECTED = 'SET_POPUP_ALL_SELECTED';
export const SET_POPUP_SELECTED_IDS = 'SET_POPUP_SELECTED_IDS';

export const REFRESH_POPUP_VIEW = 'REFRESH_POPUP_VIEW';
export const SET_MODAL_BODY = 'SET_MODAL_BODY';
export const SET_MODAL_ITEM = 'SET_MODAL_ITEM';

//************ params ************//
export const changeListParams = (menu, params) => ({
    type: CRUD_CHANGE_LIST_PARAMS,
    payload: params,
    meta: { menu },
});

//************ selectedIds ************//
export const setAllSelected = (checked, ids, itemType) => ({
    type: SET_ALL_SELECTED,
    payload: {
        checked,
        ids,
        itemType
    },
});

export const setSelectedIds = (id, itemType) => ({
    type: SET_SELECTED_IDS,
    payload: {
        id,
        itemType
    }
});

//************ selectedSearchConditions ************//
export const setSelectedFilters = (filters) => ({
    type: SET_SELECTED_SEARCH_CONDITIONS,
    payload: filters,
});

export const addSearchCondition = (searchConditionName) => ({
    type: SET_ADD_SEARCH_CONDITIONS,
    payload: searchConditionName,
});

export const removeSearchCondition = (searchConditionName) => ({
    type: SET_REMOVE_SEARCH_CONDITIONS,
    payload: searchConditionName
});

//************ refreshVersion ************//
export const refreshView = () => ({
    type: REFRESH_VIEW,
});


//************ popup ************//
export const setPopupAllSelected = (checked, ids, itemType) => ({
    type: SET_POPUP_ALL_SELECTED,
    payload: {
        checked,
        ids,
        itemType
    },
});

export const setPopupSelectedIds = (id, itemType) => ({
    type: SET_POPUP_SELECTED_IDS,
    payload: {
        id,
        itemType
    }
});

export const refreshPopupView = () => ({
    type: REFRESH_POPUP_VIEW,
});

//************ Modal창에서 사용 ************//
// Modal정보 저장 
export const setModalBody = ( modalBody ) => ({
    type: SET_MODAL_BODY,
    payload: modalBody
})

// item값 set
export const setModalItem = ( init ) => ({
    type: SET_MODAL_ITEM,
    payload: init
})
